import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-solid-circle--sprite",
  "use": "plus-solid-circle--sprite-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus-solid-circle--sprite\">\n<path d=\"m0 10c0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10z\" fill=\"var(--Black-50)\" />\n<path clip-rule=\"evenodd\" d=\"m13.5 10.5h-3v3h-1v-3h-3v-1h3v-3h1v3h3z\" fill=\"var(--Black-00)\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol